import(/* webpackMode: "eager" */ "/opt/cal.com.next/apps/web/app/error.tsx");
